<template>
  <div>
      <div class="content-box">
        <div class="element-wrapper compact pt-4" style="padding-bottom: 0">
        <div class="element-actions">
        </div>
        <h6 class="element-header">Valores a pagar</h6>
        <div class="element-box-tp">
          <div class="row">
              <div class="col-md-2">
                  <select class="form-control form-control-md bright" disabled name="ano" id="ano"
                    v-model="anoSelected">
                      <option value="">selecione</option>
                      <option v-for="ano in anos" :value="ano">{{ano}}</option>
                  </select>
              </div>
              <div class="col">
                  <div class="btn-group btn-group-md" role="group" aria-label="Basic example">
                    <button type="button" class="btn btn-success" @click="selectMes(mes)"
                      :class="{'active': mesSelected === mes}"
                      v-for="(mes) in meses" :key="mes">{{mes}}</button>
                  </div>
              </div>
          </div>
          <div class="row">
            <div class="col-lg-7 col-xxl-6">
              <!--START - BALANCES-->
              <div class="element-balances">
                <div style="margin-bottom: 0" class="balance hidden-mobile element-box el-tablo centered trend-in-corner padded bold-label">
                  <div class="balance-title">Total a Pagar {{mesSelected}}</div>
                  <div class="balance-value">
                    <span>{{totalMes | money}}</span>
                  </div>
                </div>
                </div>
              </div>
              <!--END - BALANCES-->
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-7 col-xxl-6">
        </div>
        <div class="col-lg-5 col-xxl-6">
        </div>
      </div>

      <!--START - Transactions Table-->
      <div class="content-box" style="padding-top: 0">
        <div class="element-wrapper">
          <h6 class="element-header">Transações</h6>
          <div class="element-box-tp">
            <div class="table-responsive">
              <table class="table table-padded">
                <thead>
                  <tr>
                    <th>Voucher</th>
                    <th>Data Compra</th>
                    <th>Data Atendimento</th>
                    <th class="text-center">Categoria</th>
                    <th class="text-right">Valor (R$)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="transacoesMes.length === 0">
                    <td colspan="5" class="text-center">
                      <strong>Não há transações para o mês selecionado</strong>
                    </td>
                  </tr>
                  <tr v-else
                    v-for="transacao in transacoesMes" :key="transacao.id">
                    <td class="nowrap">
                      <span class="status-pill smaller green"></span>
                      <span>{{transacao.codigo}}</span>
                    </td>
                    <td>
                      <span>{{ getDataFormatada(transacao.createdAt) }}</span>
                      <span class="smaller lighter"></span>
                    </td>
                    <td>
                      <span>{{ getDataFormatada(transacao.updatedAt) }}</span>
                      <span class="smaller lighter"></span>
                    </td>
                    <td class="text-center">
                      <a class="badge badge-success" href="#">
                        {{transacao.tipoPedido}}<span v-if="transacao.tipoPedido === 'CONSULTA'">: {{transacao.consulta.especialidade.nome}}</span>
                      </a>
                      <a v-if="transacao.tipoPedido === 'EXAME'"
                        :data-target="`#onboardingFeaturesModal-${transacao._id}`" data-toggle="modal"
                        href="#" @click="openExames(transacao)" title="Exames realizados">
                        <i class="fas fa-info-circle"></i>
                      </a>
                    </td>
                    <td class="text-right bolder nowrap">
                      <span class="text-success">{{transacao.valorTotal | money}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!--END - Transactions Table-->

     <div v-if="transacao && transacao.tipoPedido === 'EXAME'" aria-hidden="true" class="onboarding-modal modal fade animated" :id="`onboardingFeaturesModal-${transacao._id}`" role="dialog" tabindex="-1">
        <div class="modal-dialog modal-centered" role="document">
        <div class="modal-content text-center">
            <button aria-label="Close" class="close" data-dismiss="modal" type="button"><span class="close-label">Fechar</span><span class="os-icon os-icon-close"></span></button>

            <div class="onboarding-content with-gradient">
            <h4 class="onboarding-title">
                Exames Realizados
            </h4>
            <div class="row">
                <div class="col">
                    <table class="table table-lightborder">
                  <thead>
                    <tr>
                      <th>Descrição do exame</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="exame in transacao.exames" :key="exame._id">
                      <td>{{exame.nomeExame}}</td>
                    </tr>
                  </tbody>
                </table>
                </div>
            </div>
            </div>
        </div>
        </div>
    </div>

    </div>
  </div>
</template>
<script>
import * as http from 'axios'
import moment from 'moment'

export default {
  computed: {
    rede () {
      return this.$store.getters.rede
    },
    totalMes () {
      return this.transacoesMes.map(transacao => parseFloat(transacao.valorTotal, 10)).reduce((amount, value) => amount + value, 0)
    },
    transacoesMes () {
      return this.transacoes.filter(transacao => {
        let transferDate = moment(transacao.updatedAt)
        console.log('Year', transferDate.year(), 'Month', transferDate.month())
        return transferDate.year() === parseInt(this.anoSelected, 10) &&
            this.meses[transferDate.month()] === this.mesSelected
      })
    }
  },
  data () {
    return {
      anos: [],
      anoSelected: null,
      mesSelected: null,
      meses: ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'],
      transacoes: [],
      transacao: null
    }
  },
  methods: {
    selectMes (mes) {
      this.mesSelected = mes
    },
    getDataFormatada (date) {
      if (!date) {
        return ''
      }
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
    openExames (transacao) {
      this.transacao = transacao
    }
  },
  async mounted () {
    const dataAtual = new Date()
    this.anoSelected = dataAtual.getFullYear()
    this.mesSelected = this.meses[dataAtual.getMonth()]

    this.anos.push(this.anoSelected)
    for (let i = 1; i <= 4; i++) {
      this.anos.push(this.anoSelected - i)
    }
  },

  async created () {
    moment.locale('pt-br')
    try {
      const response = await http.get(`/pedidos?pagamentoAto=true&unidade=${this.rede._id}&statusAtendimento=REALIZADO`)
      this.transacoes = response.data || []
    } catch (error) {
      console.log(error)
    }
  }
}
</script>

<style scoped>
.btn {
    margin-left: 0 !important;
}
.element-balances {
  justify-content: flex-start!important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/financeiro/Pagar.vue